// RV Organica — Blog reading progress bar + smooth anchor scroll
(function () {
  var bar = document.getElementById('rvo-progress');
  if (!bar) return;

  function updateProgress() {
    var scrolled = window.scrollY;
    var total = document.documentElement.scrollHeight - window.innerHeight;
    bar.style.width = total > 0 ? Math.min((scrolled / total) * 100, 100) + '%' : '0%';
  }

  window.addEventListener('scroll', updateProgress, { passive: true });
  updateProgress();

  // Smooth scroll for TOC links
  document.querySelectorAll('.rvo-toc__item a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();
